import * as React from 'react'
import { Grid } from '@mui/material'

import BITableContent from './Table'
import BIChartContent from './Chart'
import { useSubmitBIFilters } from './@hooks'
import BIUrlModal from 'Pages/BusinessLogistics/BI/Page/UrlModal'
import BITableActions from './@components/Table/Actions'
import BI3DTable from './3DTable'


export default function BIPageContent() {

	useSubmitBIFilters()

	return <Grid container spacing={2}>
		<Grid item xs={12} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
			<BITableActions/>
		</Grid>
		<Grid item xs={12}>
			<BI3DTable />
			<BITableContent/>
		</Grid>
		<Grid item xs={12}>
			<BIChartContent/>
		</Grid>
		<Grid item xs={12}>
			<BIUrlModal/>
		</Grid>
	</Grid>
}